import activeTab from './modules/store'

export const modules = {
  activeTab
}



// WEBPACK FOOTER //
// ./src/store/ActiveTab/index.js